import "./assets/css/styles.css";
import React from 'react';
import ReactDOM from 'react-dom';
import NotFound from './pages/NotFoundPage';
import * as serviceWorker from './utils/serviceWorker';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import HomePage from './pages/Login/HomePage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import SearchListPage from './pages/Search/SearchListPage';
import AnsweredListPage from './pages/Answered/AnsweredListPage';
import RecoverPasswordPage from './pages/Login/RecoverPasswordPage';
import SearchDetailPage from './pages/Search/SearchDetailPage';
import ProviderRegisterPage from './pages/ProviderRegister/ProviderRegisterPage';
import ProfilePage from './pages/Profile/ProfilePage';
import EmployeePage from "./pages/Employee/Employee";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Route path='/' exact={true} component={HomePage} />
      <Route path='/recover-password' exact={true} component={RecoverPasswordPage} />
      <Route path='/register' exact={true} component={ProviderRegisterPage} />
      <Route path='/home' exact={true} component={DashboardPage} />
      <Route path='/search' exact={true} component={SearchListPage} />
      <Route path='/search/:id' exact={true} component={SearchDetailPage} />
      <Route path='/answered' exact={true} component={AnsweredListPage} />
      <Route path='/profile' exact={true} component={ProfilePage} />
      <Route path='/funcionarios' exact={true} component={EmployeePage} />
      <Route component={NotFound} />
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
